import { ErrorState } from '@/components/ui/empty-state';
import { useRouteError } from 'react-router';

export default function RouteErrorBoundary() {
    const error = useRouteError() as { message?: string; statusText?: string } | undefined;
    const detail = error?.statusText || error?.message || '';

    return (
        <ErrorState
            detail={detail || undefined}
            onRetry={() => window.location.reload()}
            description="Произошла ошибка при отображении страницы. Попробуйте обновить — данные не потеряны."
        />
    );
}
